// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PreCalculation.yaml
// Generated: 2026-10-21T12:24:51.481Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePreCalculation, UpdatePreCalculation, PreCalculation } from '@/types/forestry/PreCalculation';

/**
 * PreCalculation Service
 * CRUD operations for PreCalculation via the ABP API.
 */
export const preCalculationService = new EntityService<PreCalculation, CreatePreCalculation, UpdatePreCalculation>(
  '/api/forestry/precalculation',
  'PreCalculation',
);
